<template>
  <el-drawer
    v-model="carAttrDrawer"
    title="车型参数"
    direction="rtl"
    :before-close="handleClose"
    :size="'auto'"
    custom-class="customDrawerClass"
  >
    <div class="attrDrawer">
      <div class="left">
        <div
          v-for="(tab, index) in filterTabRef"
          :key="tab.text"
          class="leftRow"
          :class="{ active: index == tabIndex }"
          @click="changeTab(index)"
        >
          {{ tab.text }}
        </div>
      </div>
      <div class="line"></div>
      <div class="right" v-if="filterTabRef && filterTabRef[tabIndex] && filterTabRef[tabIndex]['attr'] && filterTabRef[tabIndex]['text']">
        <!-- <div class="tableHead">{{ filterTabRef[tabIndex]["text"] }}</div> -->
   
        <table class="attrs_table" border="1">
          <tr>
            <td colspan="3" class="model_name">
              {{car_info['brand']}}{{car_info['model_name']}}
            </td>
          </tr>
          <tr v-for="field in filterTabRef[tabIndex]['attr']" :key="field.id">
            <td class="tr_attr attrs_td" v-if="!(filterTabRef && filterTabRef[tabIndex] && filterTabRef[tabIndex]['attr'].length==1 &&(filterTabRef[tabIndex]['text'] == filterTabRef[tabIndex]['attr'][0]['text']))">
              {{field && field.text}}
            </td>
            <template v-if="field['attr'] && field['attr'].length>0">
              <td>
                <table class="tr_table">
                  <template v-for="(item,ind) in field['attr']" :key="ind">
                    <tr v-if="item.field!='brand' && item.field!='model_name'">
                      <td class="tr_attr attrs_td">
                        {{item.text}}
                      </td>
                      <td class="tr_val attrs_td">
                        {{car_info && item &&item.field && car_info[item.field] || '-'}}
                      </td>
                    </tr>
                  </template>
                  
                </table>
              </td>
            </template>
            <template v-else>
              <td>
                {{car_info && field &&field.field && car_info[field.field]}}
              </td>
            </template>
            
          </tr>

        </table>
        <!-- <div
          v-for="field in filterTabRef[tabIndex]['attr']"
          :key="field.id"
          class="tableRow"
        >
          <div class="rowLeft row">{{field && field.text }}</div>
          <div class="rowRight row">{{ car_info && field &&field.field && car_info[field.field] }}</div>
        </div> -->
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { ElDrawer } from "element-plus";
import { ref, watch } from "vue";
import { getCarLibrary, getCarFilterConfig } from "@/api";
import {
  getCarLibrary as getCarLibrary2,
  getCarFilterConfig as getCarFilterConfig2,
} from "@/api_drive";
export default {
  name: "carAttr",
  components: {
    ElDrawer,
  },
  props: ["route_type"],
  setup(props) {
    const model_id = ref(0);
    const carAttrDrawer = ref(false);
    const car_info = ref({});
    const filterTabRef = ref([]);
    const tabIndex = ref(0);
    const getCarFilterConfigData = () => {
      if (props.route_type == "drive") {
        getCarFilterConfig2({
          filter_flag:1
        }).then((res) => {
          if (res.code == 200) {
            filterTabRef.value = res.data.tab;
          }
        });
      } else {
        getCarFilterConfig({
          filter_flag:1
        }).then((res) => {
          if (res.code == 200) {
            filterTabRef.value = res.data.tab;
          }
        });
      }
    };
    const showCarAttr = () => {
      if (props.route_type == "drive") {
        getCarLibrary2({ id: model_id.value }).then((res) => {
          car_info.value = res.data.list[0];
          changeTab(0);
        });
      } else {
        getCarLibrary({ id: model_id.value }).then((res) => {
          car_info.value = res.data.list[0];
          changeTab(0);
        });
      }
    };
    watch(model_id, () => {
      showCarAttr();
    });

    getCarFilterConfigData();

    const changeTab = (index) => {
      tabIndex.value = index;
    };

    return {
      carAttrDrawer,
      model_id,
      car_info,
      filterTabRef,
      tabIndex,
      changeTab,
    };
  },
};
</script>
<style lang="less" scoped>

.row {
  min-height: 50px;
  padding: 10px;
  border: 1px solid #d0d7f4;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: none;
  border-bottom: none;
}
.tableRow {
  display: flex;
  width: 468px;
  font-size: 14px;
  &:last-child {
    border-bottom: 1px solid #d0d7f4;
  }
}
.tableRow:nth-child(odd) {
  background: #f5f8fc;
}
.rowLeft {
  width: 234px;
  display: flex;
  justify-content: center;
  border-left: 1px solid #d0d7f4;
}
.rowRight {
  width: 234px;
  display: flex;
  justify-content: center;
}
// .tableHead {
//   width: 600px;
//   height: 47px;
//   background: #f5f8fc;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   font-size: 16px;
//   font-weight: bold;
//   color: #474747;
//   line-height: 24px;
//   border: solid 1px #d0d7f4;
//   border-bottom: none;
// }

.attrDrawer {
  width: 805px;
  height: 100%;
  display: flex;
}
.left {
  padding: 0px 23px;
  width: 180px;
  flex-shrink: 0;
}
.right{
  width: 600px;
  padding-bottom: 100px;
  overflow-x: hidden;
  overflow-y: auto;
}
.leftRow {
  width: 100%;
  height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  font-size: 16px;
  color: #474747;
  line-height: 24px;
  cursor: pointer;
}
.leftRow:hover {
  color: #1FBCBF;
}
.leftRow.active {
  background: #1FBCBF;
  color: #ffffff;
}
// .line {
//   width: 1px;
//   height: 870px;
//   /* border: 1px solid #D0D7F4; */
//   background: #d0d7f4;
// }
table{
  width: 100%;
  border-collapse:collapse;
}
.attrs_table{
  width: 600px;
  border-color:#dee6f2;
  .model_name{
    background: #f5f8fc;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
  }
  .tr_attr{
    width: 160px;
    border-right: solid 1px #d0d7f4;
    border-bottom: solid 1px #d0d7f4;
  }
  .tr_val{
     border-bottom: solid 1px #d0d7f4;
  }
  .tr_table tr:nth-last-child(1) .tr_attr,.tr_table tr:nth-last-child(1) .tr_val{
    border-bottom: none;
  }
  td{
  
    text-align: center;
    font-size: 14px;
  }
  .attrs_td{
    padding: 5px 10px;
  }
}
</style>

<style>
.customDrawerClass {
  overflow: auto;
}
.el-drawer__body{
  height: calc(100% - 75px);
}
.el-overlay .el-drawer__header{
  font-size: 20px;
  margin-bottom: 28px;
}

</style>
